import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VAutocomplete, {
    class: "".concat(_vm.required ? "required" : "", " ").concat(_vm.classStyle),
    attrs: {
      clearable: _vm.clearable,
      disabled: _vm.disabled || _vm.isReloading || _vm.suppliers.length === 0,
      "hide-selected": _vm.hideSelected,
      rules: _vm.rules,
      items: _vm.suppliers,
      "item-text": "display_name",
      "item-value": "id",
      placeholder: "Select a supplier",
      label: _vm.suppliers.length === 0 ? "Loading suppliers..." : _vm.label,
      "hide-details": "auto",
      "return-object": "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      input: _vm.changeSupplier
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "mt-2 mb-2"
        }, [_vm._v(_vm._s(item.display_name))]), _c(VSpacer), !item.producerId ? _c(VBtn, {
          attrs: {
            icon: ""
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return function () {
                _vm.editSupplier = item;
                _vm.supplierModalShown = true;
              }.apply(null, arguments);
            }
          }
        }, [_c(VIcon, {
          attrs: {
            title: "Edit supplier",
            small: ""
          }
        }, [_vm._v("mdi-pencil")])], 1) : _vm._e()];
      }
    }, {
      key: "append-outer",
      fn: function fn() {
        return [_c(VIcon, {
          attrs: {
            disabled: _vm.disabled,
            loading: _vm.isLoadingCountries,
            title: "Add new supplier",
            small: ""
          },
          on: {
            click: function click() {
              _vm.editSupplier = null;
              _vm.supplierModalShown = true;
            }
          }
        }, [_vm._v(" fa-plus ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.model,
      callback: function callback($$v) {
        _vm.model = $$v;
      },
      expression: "model"
    }
  }), _vm.supplierModalShown ? _c("SupplierDialog", {
    attrs: {
      shown: _vm.supplierModalShown,
      countries: _vm.countries,
      states: _vm.states,
      supplier: _vm.editSupplier
    },
    on: {
      save: _vm.saveSupplier,
      close: _vm.closeNewSupplierDialog
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };